export default __webpack_public_path__ + "static/media/bg2.94743b86.jpg";